import { find, get } from 'lodash';

export const findItemByKeyValue = (items, key, value) =>
    find(items, (item) => get(item, key) === value) || null;
